export default __webpack_public_path__ + "static/media/kyc.2b013ff6.png";